module.exports = __webpack_public_path__ + "static/diary_demo-8ddaf77f83cb3b65ed3194289d4726fe.gif";